<template>
  <span>{{ displayText }}</span>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'AgentFieldView',
  props: {
    agentId: {
      type: Number,
      required: false,
    },
    display: { type: Array },
    unknownLabel: { type: String },
  },
  setup(props) {
    const store = useStore();

    const displayColumn = (agentId, col) => {
      const agent = store.getters['agents/getAgent'](agentId);
      return agent ? agent[col] : 'Unknown';
    };

    const displayText = computed(() => {
      return store.getters['agents/getAgent'](props.agentId) ?
      props.display
        .map((col) => displayColumn(props.agentId, col))
        .join(' ')
        : props.unknownLabel ?? 'Unknown';
    });

    onMounted(async () => {
      if (
        !store.getters['agents/getAgents'] ||
        store.getters['agents/getAgents'].length === 0
      ) {
        await store.dispatch('agents/fetchAgents');
      }
    });

    return {
      displayText,
    };
  },
};
</script>
